export const HABERES_VARIABLES_MODULE_ID = 'haberes_variables'
export const RECURSOS_HUMANOS_CATEGORY_ID = 'recursos_humanos'

export { defaultConfiguracionEquipoAccess as defaultHaberesVariablesAccess } from './configuracionEquipoModule'
